import { goToMoversProcess } from '../../../services/ProcessStep';
import { HIGH } from '../../Web/DeviceSetup/constants';
import { getFullAddress } from '../../common/ContactInfoUtils';
import { getSession, isCurrentPlanVHILite, isMoversEdgePhase1Flag, isMoversFlow, isVHILiteQualified } from '../../common/Helpers';
import { capitalizeFirstLetterofWord } from '../../common/Helpers/capitalize';
import { eventDispatcher } from '../../common/Tagging';
import { getNetworkBandWidthIndicator, isLiketoLikeFlow } from '../../common/plansUtils';
import { getDateWithSlash, getVideoUrl } from '../MoversDeviceSetup/helperFile';
import { INSTALL_TYPE_TO_DEPLETION_MAP, INSTALL_MOVERS_TYPE_TO_DEPLETION_MAP } from './constants';

export const removeCSSProperty = (elementRef, properties) => {
  if(elementRef?.style){
    properties.forEach((propertyKey) => elementRef.style.removeProperty(propertyKey));
  }
}

export const hideMobileCartDueMonthly = () => {
  const rootSelctor= document.documentElement;
  if(!isMoversPhase3() || !rootSelctor?.style) {
    return;
  }
  if(!isLiketoLikeFlow()) {
    removeCSSProperty(rootSelctor, ['--dueMonthly-summary-display','--dueMonthly-total-visibility']);
  } else {
    rootSelctor.style.setProperty('--dueMonthly-summary-display', 'none');
    rootSelctor.style.setProperty('--dueMonthly-total-visibility', 'hidden');
  }
}

export const parseLQResponse = (LQResponseData) => {
  let lqResponse = {};
  if (LQResponseData) {
    try {
      lqResponse = JSON.parse(LQResponseData);
    } catch (error) {
      console.error('JSON parsing error', error);
      lqResponse = {};
    }
  }
  return lqResponse;
};

export const formatAddress = (parsedResponse) => {
  const { addressLine1 = '', addressLine2 = '', city = '', state = '', zipCode = '' } = parsedResponse?.output || {};
  const addressLine = [addressLine1, addressLine2].filter(Boolean).join(', ');
  return [capitalizeFirstLetterofWord(addressLine), capitalizeFirstLetterofWord(city), state, zipCode].filter(Boolean).join(', ');
};

export const isMoversPhase3 = () => isMoversFlow() && getSession('moversPhaseThreeQualFFlag') === 'true';

export const enableMoversPh3Tagging = () => isMoversPhase3() && getSession('enableMoversPh3Tagging') === 'true';

export const isProSetupEligible = () => {
  const lqresponse = parseLQResponse(getSession('LQResponse'));
  return isDeviceChangeRequired() && lqresponse.output?.bundleDetails?.some((setupOption) => setupOption.type === 'p');
};

export const hasLimitedSetupOptions = () => {
  const lqresponse = parseLQResponse(getSession('LQResponse'));
  return (lqresponse?.output?.bundleDetails?.length ?? 0) < 2;
}


export const isMiniCartDeviceUpgradeRequired = () => {
  const { pathname } = window.location;
  const pageName = pathname?.split('/')?.pop()?.replace('.html', '');
  const isDeviceSetupPage = pageName === 'moversDeviceSetup';
  return isLiketoLikeFlow() && isDeviceChangeRequired() && !isDeviceSetupPage && isMoversPhase3();
};

export const isMiniCartDeviceShouldBeHidden = () => {
  const rootSelctor= document.documentElement;
  if(!rootSelctor?.style) {
    return;
  }
  const hideDevice = !isDeviceChangeRequired();
  if(hideDevice) {
    rootSelctor.style.setProperty('--dueToday-device-display', 'none');
  } else {
    removeCSSProperty(rootSelctor, ['--dueToday-device-display']);
  }
};


export const isCrossBand = () => !isLiketoLikeFlow() && isMoversPhase3();

export const isMiniCartRequired = () => {
  const showMiniCart =  isCrossBand() ||  isMiniCartDeviceUpgradeRequired();
  if(showMiniCart){
    hideMobileCartDueMonthly();
  }
  if (isMoversPhase3()){
    isMiniCartDeviceShouldBeHidden();
  }
  return showMiniCart;
};

export const showDeviceCarryMsg = () => {
  const getNbw = getNetworkBandWidthIndicator();
  return !isDeviceChangeRequired() && getNbw?.currentBandWidth === 'LTE' && isLiketoLikeFlow();
};
export const carryDeviceMsgCbdToLte = () => {
  const { previousBandWidth, currentBandWidth } = getNetworkBandWidthIndicator();
  return !isDeviceChangeRequired() && previousBandWidth === 'CBD' && currentBandWidth === 'LTE';
};

export const carryDeviceMsgCbdToCbd = () => {
  const { previousBandWidth } = getNetworkBandWidthIndicator();
  return !isDeviceChangeRequired() && previousBandWidth === 'CBD' && isLiketoLikeFlow();
};

export const carryDeviceMsgLteToCbd = () => {
  const { previousBandWidth, currentBandWidth } = getNetworkBandWidthIndicator();
  return !isDeviceChangeRequired() && previousBandWidth === 'LTE' && currentBandWidth === 'CBD';
};

export const getDepletionType = (cartDetailsJson,moversPh3ContinueBtnFixFFlag) => {
  let installType;
  if (moversPh3ContinueBtnFixFFlag) {
    const deviceItem = cartDetailsJson?.dueTodayList?.find((item) => item?.itemType === 'DEVICE');
    installType = cartDetailsJson?.orderDetailsView?.installType || deviceItem?.installationType;
  } else {
    installType = cartDetailsJson?.orderDetailsView?.installType;
  }
  
  return INSTALL_TYPE_TO_DEPLETION_MAP[installType];
};

export const getMoversDepletionType = (cartDetailsJson) => {
  const installType = cartDetailsJson?.moveServiceInfo?.installationType;
  return INSTALL_MOVERS_TYPE_TO_DEPLETION_MAP[installType];
};

export const formatMoveDates = (date) => {
  if (!date) {
    return null;
  }
  return date.replace(',', ',');
};

export const formatCartAddress = (cartAddress) => {
  if (!cartAddress) {
    return '';
  }
  const modifiedAdress = { ...cartAddress };
  const convertToLowerCase = ['addressLine1', 'addressLine2', 'city'];
  convertToLowerCase.forEach((item) => {
    modifiedAdress[item] = capitalizeFirstLetterofWord(modifiedAdress?.[item]);
  });
  return getFullAddress(modifiedAdress);
};

export const getProfessionalInfo = (cart5GAppointment) => {
  if (!cart5GAppointment) {
    return {};
  }
  const dateObj = cart5GAppointment?.profInstallDate;
  const month = parseInt(dateObj?.substring(4, 6));
  const day = parseInt(dateObj?.substring(6, 8));
  const year = dateObj?.substring(0, 4);
  const date = new Date(`${year}-${month}-${day}`);
  const options = { weekday: 'long', month: 'short', day: '2-digit', year: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options).replace(/ /g, ' ').replace(',', ',');
  const startHour = cart5GAppointment?.slotStartTime?.split(':')?.[0]?.replace(/^0/, '');
  const endHour = cart5GAppointment?.slotEndTime?.split(':')?.[0]?.replace(/^0/, '');
  const period = cart5GAppointment?.slotEndTime?.split(' ')?.[1] || '';
  return {
    date: formattedDate,
    timeSlot: `between ${startHour}:00 and ${endHour}:00 ${period}`,
  };
};

export const truncateToDateOnly = (dateString) => {
  const day = new Date(dateString);
  day.setHours(0, 0, 0, 0);
  return day.toDateString();
};

export const getDeviceImage = (salesRetrieveCart, moversRetrieveCart) => {
  if (isDeviceChangeRequired()) {
    return salesRetrieveCart?.cartDetailsJson?.dueTodayList?.find((item) => item?.itemType === 'DEVICE')?.imageUrlMap;
  }

  return moversRetrieveCart?.imageUrlMap || {};
};

export const isDeviceChangeRequired = () => {
  const lqresponse = parseLQResponse(getSession('LQResponse'));
  const isDeviceChangeRequiredValue = lqresponse?.output?.deviceChangeRequired || false;
  return isDeviceChangeRequiredValue
}

export const extractHour = (time) => time?.replace(/^0/, '');

export const shouldShowDeviceCarryMsg = () => {
  const showDevicecarryMsgLteToLte = showDeviceCarryMsg();
  const showDevicecarryMsgCbdToLte = carryDeviceMsgCbdToLte();
  const showDeviceCarryMsgCbdToCbd = carryDeviceMsgCbdToCbd();
  const showDeviceCarryMsgLteToCbd = carryDeviceMsgLteToCbd();
  return showDevicecarryMsgLteToLte || showDevicecarryMsgCbdToLte || showDeviceCarryMsgCbdToCbd || showDeviceCarryMsgLteToCbd;
};

export const isStalledCbandMove = () => {
  const lqresponse = parseLQResponse(getSession('LQResponse'));
  const { planChangeRequired, qualifiedCBand, availableSpeedTier } = lqresponse?.output || {};
  return planChangeRequired === true && qualifiedCBand === true && availableSpeedTier === '100';
}

export const moversOverViewRedirection = (previousNetworkBandwidth, currentNetworkBandwidth, isPlanChangeRequired, moversFFlags) => {
  const isVHILitePlan = isCurrentPlanVHILite();
  const isVHILiteQualifiedForMove = isVHILiteQualified();
  const redirectToDeviceSetup = ((isVHILitePlan && isVHILiteQualifiedForMove && isMoversEdgePhase1Flag()) || (!isVHILitePlan && !isVHILiteQualifiedForMove));
  const redirectToPlansOverview = (currentNetworkBandwidth === previousNetworkBandwidth) && 
  ((!isVHILitePlan && isVHILiteQualifiedForMove) || (isVHILitePlan && !isVHILiteQualifiedForMove)) && isMoversEdgePhase1Flag();
  const isStalledCbandMoveFlag = isStalledCbandMove();
  if(moversFFlags?.cbandStalledPlansUIFFlag && isStalledCbandMoveFlag){
    goToMoversProcess('MOVERS_PLANS_OVER_VIEW');
    return;
  }
  if (currentNetworkBandwidth === previousNetworkBandwidth && !isPlanChangeRequired && redirectToDeviceSetup) {
    goToMoversProcess('MOVERS_DEVICE_SET_UP');
  } else if (isPlanChangeRequired && ((currentNetworkBandwidth !== previousNetworkBandwidth) || redirectToPlansOverview)) {
    goToMoversProcess('MOVERS_PLANS_OVER_VIEW');
  }
}

export const generateMoversMarkerClass = (elementName) => isMoversPhase3() ? `movers${elementName}` : '';

export const getSetupVideoData = (storeDetailData, cartDetailData) => {
  const plansReference = storeDetailData?.plansReferenceData?.output || {};
  const cartEligibleBundlesData = cartDetailData?.cartDetailsJson?.orderDetailsView?.eligible5GHomeBundle;
  const planOptionInfoData = getVideoUrl(cartEligibleBundlesData, plansReference, cartDetailData?.cartDetailsJson?.dueTodayList);
  return planOptionInfoData?.length ? planOptionInfoData?.[0] : {};
}

export const deviceChangeLTEtoLTE = () => {
  const deviceChange = isDeviceChangeRequired();
  const getNbw = getNetworkBandWidthIndicator();
  return deviceChange && getNbw?.currentBandWidth === 'LTE' && isLiketoLikeFlow();
};

export const getPaymentFromCheckout = (paymentDetails) => {
  const payments = [];
  if (paymentDetails) {
    Object.keys(paymentDetails).forEach((data) => {
      const payment = paymentDetails[data];
      payments.push(payment);
    });
  }
  return payments;
}

export const hideDeviceForMoversDueToday = (itemType) => {
  let hideDeviceDetail = false;
  if(isMoversPhase3() && itemType === 'DEVICE' && !isDeviceChangeRequired()) {
    hideDeviceDetail = true;
  }
  return hideDeviceDetail;
}

export const checkIsISPU = (checkoutResponse) => {
  const lines = checkoutResponse?.shipment?.lines;
  if(!lines){
    return false;
  }
  const firstKey = Object.keys(lines)?.[0];
  const selectedOptionCode = lines[firstKey]?.selectedOptionCode;
  return selectedOptionCode === 'ISPU';
}
export const getMoversDeviceClass = (deviceType) => {
  if (deviceType === 'DEVICE') {
    generateMoversMarkerClass('DeviceProduct')
  }
  else {
    return '';
  }
}

export const formatDate = (dateString) => {
  if(!dateString || typeof dateString !== 'string') {
    return '';
  }
  const dateParts = dateString?.split('/');
  if(dateParts.length !== 3) {
    return '';
  }
  const [month, day, year] = dateParts;
  if(!month || !day || !year) {
    return '';
  }
  const date = new Date(year, month - 1, day);
  const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
  return date.toLocaleDateString('en-US', options);
}

export const isDateWithin48Hours = (date1) => {
  if (!date1) {
    return false;
  }
  const diffInTime = Math.abs(new Date(date1) - new Date());
  const diffInDays = diffInTime / (1000 * 60 * 60 * 24);
  return diffInDays <= 2;
};


export const getComparePlanFromProductRefUIFFlag = (cartDetails) => {
  const getComparePlanFromProdRefData = cartDetails?.comaprePlanFromProductRefUIFFlag || false;
  return getComparePlanFromProdRefData;
};

export const getComparePlanFromProductRefValues = (progressivePlans, storeDetails, newPlanId) => {
  const plansReferenceData = storeDetails?.plansReferenceData?.output || {};
  const planRefWillowFeature = plansReferenceData?.willowFeatures || {};
  const [lines] = progressivePlans?.data?.lineLevelPlans?.lines || [];
  const planDetails = lines?.products?.[0]?.plans;
  const newPlanObj = planDetails?.filter((plan) => (plan?.planId) === String(newPlanId))[0] || {};
  const newObj = {
    planDisplayName: newPlanObj?.displayName,
    finalPrice: newPlanObj?.price?.discPriceWOAutoPay,
    planId: newPlanObj?.planId,
  };
  return { planRefWillowFeature, newObj };
};

export const  enableShippingOTPFixFFlag = (cartDetails) => {
  const isShippingOTPFixEnabled = cartDetails?.enableShippingOTPFixFFlag || false;
  return isShippingOTPFixEnabled;
}

export const getSpeedTierRequestData = () => {
  const lqData = parseLQResponse(getSession('LQResponse'))?.output;
  if (lqData?.cBandStalledSectorFFlag && lqData?.availableSpeedTier) {
    return { availableSpeedTier: lqData?.availableSpeedTier };
  }
  return {};
}

export const  getSkipRedisCacheUIFFlag = (cartDetails) => {
  const skipRedisCache = cartDetails?.skipRedisCacheUIFFlag || false;
  return skipRedisCache;
}

export const enableMoversPhase3TaggingFFlag = (cartDetails) => {
  const enableMVPH3Tagging = getSession('enableMoversPh3Tagging') === 'true' || cartDetails?.moversPhase3TaggingFFlag || false;
  return enableMVPH3Tagging;
}

export const enableLinkToMoversHubFFlag = (cartDetails) => {
  const enableLinkToMoversHub = cartDetails?.linkToMoversHubUIFFlag || false;
  return enableLinkToMoversHub;
}

export const enableValidateCartAndCheckout  = (cartDetails) => {
  const validateCartAndCheckout = cartDetails?.moversValidateCartAndCheckoutUIFFlag || false; 
  return validateCartAndCheckout;
}

export const enableTechRecommendationBadge = (cartResponse, moveServiceInfo) => {
  const techRecommendationFFlag = moveServiceInfo?.enableTechRecommenderFFlag || false;
  const techRecommendation = cartResponse?.cartDetailsJson?.cart5GAddress?.techRecommendation || '';
  const setupForBadge = String(techRecommendation).toLowerCase() === HIGH;
  return techRecommendationFFlag && setupForBadge;
}

export const enableShippingMobileOTPFixFFlag  = (cartDetails) =>{
  const isShippingMobileOTPFixEnabled = cartDetails?.enableShippingMobileOTPFixFFlag; 
  return isShippingMobileOTPFixEnabled;
}

export const getDefaultShipmentOptionFFlag  = (cartDetails) => {
  const getDefaultShipmentOption = cartDetails?.defaultMoversShipmentUIFFlag || false; 
  return getDefaultShipmentOption;
}

export const getTechRecommendationBadgeRight = (isMobileDevice, carouselIndex) => {
  if (!isMobileDevice) {
    return '0px';
  }
  return !carouselIndex ? '-18%' : '0px';
};

export const getTaggingNotification = (bannerMessage) => {
  eventDispatcher('notify', {
    name: bannerMessage,
    data: {
      page: {
        detail: 'message displayed',
      },
    },
  });
}

export const findTheEarliestAppointmentDate = (availableAppointments) => {
  if (!availableAppointments?.length) {
    return null;
  }
  return availableAppointments.reduce((earliest, appointment) => {
    const appointmentDate = new Date(getDateWithSlash(appointment.date));
    return appointmentDate < earliest ? appointmentDate : earliest;
  }, new Date(getDateWithSlash(availableAppointments[0].date)));
};
